import { render } from "./ConfigOption.vue?vue&type=template&id=24ad142e&scoped=true"
import script from "./ConfigOption.vue?vue&type=script&lang=js"
export * from "./ConfigOption.vue?vue&type=script&lang=js"

import "./ConfigOption.vue?vue&type=style&index=0&id=24ad142e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad142e"]])

export default __exports__